import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { subscriptionApi } from '../api/subscription.api'

export function useSubscription() {
  return useQuery({
    queryKey: ['subscription'],
    queryFn: async () => {
      try {
        const r = await subscriptionApi.fetchSubscription()
        return r.data.data
      } catch (error: unknown) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          return null
        }
        throw error
      }
    },
    staleTime: 60_000,
    retry: false,
  })
}
